/* 9/9 Day landing page. Included by several sections, so init is guarded. */

(() => {
  if (window.nineNine) return;

  /* Read before location-detector.js (end of theme.liquid) strips ?loc=. */
  const HAS_DEEP_LINK = /[?&]loc=/.test(window.location.search);

  /* Detector applies ?loc= async; poll rather than read localStorage once. */
  const SELECTION_POLL_TRIES = 25;
  const SELECTION_POLL_INTERVAL_MS = 200;

  let syncing = false;

  const norm = (value) => (value || '').toString().trim().toLowerCase();

  /* Hero/offers/prices render from cart.attributes.facility. The detector
     reloads after a ?loc= deep link itself; this catches any other case where
     the saved facility and the rendered one differ. */
  const syncFacility = (band) => {
    if (syncing) return;

    const rendered = norm(band.getAttribute('data-nn-rendered'));
    /* Empty means the detector will reload; don't race it. */
    if (!rendered) return;

    /* Fallback (no selection / coming-soon) is intentional — a reload won't fix it. */
    if (norm(band.getAttribute('data-nn-selected')) !== 'true') return;

    const city = localStorage.getItem('location');
    const facility = localStorage.getItem('selected_facility');
    /* Blank city makes dynamic-link render CTAs as text site-wide. */
    if (!city || !facility) return;
    if (norm(facility) === rendered) return;

    /* One attempt per pair, set only after a successful write: a failed POST
       leaves the flag unset so the next poll tick tries again. */
    const flag = `nn-sync:${rendered}>${norm(facility)}`;
    if (sessionStorage.getItem(flag)) return;

    syncing = true;
    /* Locale-prefixed storefronts serve cart endpoints under that prefix. */
    const cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { location: city, facility: facility } }),
    })
      .then((response) => {
        if (!response.ok) {
          syncing = false;
          return;
        }
        sessionStorage.setItem(flag, '1');
        window.location.reload();
      })
      .catch((error) => {
        syncing = false;
        console.error('9/9 Day: could not sync the selected location', error);
      });
  };

  const watchFacility = (band) => {
    if (!HAS_DEEP_LINK) {
      syncFacility(band);
      return;
    }
    let tries = 0;
    const check = () => {
      syncFacility(band);
      /* Not gated on `syncing` — syncFacility already returns while a write is
         in flight, and bailing here would kill the loop before a failed POST
         could be retried. */
      if (tries >= SELECTION_POLL_TRIES) return;
      tries += 1;
      setTimeout(check, SELECTION_POLL_INTERVAL_MS);
    };
    check();
  };

  const bindChange = (scope) => {
    const buttons = scope.querySelectorAll('[data-nn-change]');
    buttons.forEach((button) => {
      if (button.dataset.nnBound) return;
      button.dataset.nnBound = '1';
      button.addEventListener('click', () => {
        const detector = window.locationDetector;
        if (!detector || typeof detector.showCitySelectionModal !== 'function') return;
        /* saveLocation assigns this URL; a leftover #fragment is same-document
           nav and would keep the old facility. */
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        detector.showCitySelectionModal();
      });
    });
  };

  const init = (scope) => {
    const root = scope || document;
    bindChange(root);

    /* Theme editor re-renders constantly; a reload would fight it. */
    if (window.Shopify && window.Shopify.designMode) return;

    const band = root.querySelector('[data-nn-rendered]');
    if (band) watchFacility(band);
  };

  window.nineNine = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  /* Section re-render in the editor drops our listeners. */
  document.addEventListener('shopify:section:load', (event) => {
    bindChange(event.target);
  });
})();
